var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

window.onYouTubeIframeAPIReady = function () {
	var $player = $('#player'), id = $player.data('yt-id') ? $player.data('yt-id') : 'SKkXdK4uZ5E';
	var player = new YT.Player('player', {
		width: '100%',
		height: '100%',
		suggestedQuality: 'hd720',
		videoId: id,
		playerVars: {
			list: $player.data('yt-list'),
			listType: 'playlist',
			autoplay: 0
		},
		events: {
			onStateChange: onPlayerStateChange
		}
	});
}

function onPlayerStateChange(event) {
	if(event.target.getPlayerState() === 0) {
		event.target.previousVideo();
		event.target.stopVideo();
	}
}